import React from "react";
import PropTypes from "prop-types";
// Graphql
// SCSS
import { Box, Card, Typography } from "@mui/material";
import { validateRoute } from "../../../../utils/helpers";
import { ECurrencyCode } from "../../../../Enums/Coin";

function CardProductSelected({
  product,
  onClickDecrement,
  onClickIncrement,
  currentSymbolCoin,
  currentCoinCode,
  convertToCurrency,
}) {
  return (
    <Card
      color="primary"
      sx={{
        maxHeight: "124px",
        paddingY: "1rem",
        paddingX: { xs: "1rem", sm: "1rem", md: "1rem" },
        gap: "1rem",
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        alignItems: "center",
      }}
    >
      <div>
        <Typography
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100px",
          }}
          typography="modeColor"
          variant="subtitle1"
        >
          {product.label}
        </Typography>
        <Typography
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100px",
          }}
          typography="modeColor"
          variant="subtitle1"
        >
          {product.description}
        </Typography>
        <Typography
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100px",
          }}
          typography="modeColor"
          variant="subtitle1"
        >
          {currentSymbolCoin}
          {convertToCurrency({
            amount: Number(product?.unit_price),
            fromCurrencyCode: ECurrencyCode.DOLLAR,
            toCurrencyCode: currentCoinCode,
            decilmalsNumber: 3,
          })}
        </Typography>
      </div>

      <div className="content-flex-row-between" style={{ width: "5rem" }}>
        <div
          className="products-buttons"
          role="button"
          tabIndex={0}
          onClick={onClickDecrement}
          onKeyDown={() => null}
        >
          <Typography
            sx={{ cursor: "pointer" }}
            typography="modeColor"
            variant="subtitle1"
          >
            -
          </Typography>
        </div>
        <Typography typography="modeColor" variant="subtitle1">
          {product.quantity}
        </Typography>
        <div
          className="products-buttons"
          role="button"
          tabIndex={0}
          onClick={onClickIncrement}
          onKeyDown={() => null}
        >
          <Typography
            sx={{ cursor: "pointer" }}
            typography="modeColor"
            variant="subtitle1"
          >
            +
          </Typography>
        </div>
      </div>
      <Box
        alt="Imagen de Producto"
        component="img"
        src={validateRoute(product)}
        sx={{
          width: "100%",
          maxHeight: "82px",
          objectFit: "contain",
        }}
      />
    </Card>
  );
}

CardProductSelected.propTypes = {
  product: PropTypes.object.isRequired,
  onClickIncrement: PropTypes.func,
  onClickDecrement: PropTypes.func,
  currentSymbolCoin: PropTypes.any,
  currentCoinCode: PropTypes.string,
  convertToCurrency: PropTypes.func,
};
CardProductSelected.defaultProps = {
  onClickIncrement: () => null,
  onClickDecrement: () => null,
  currentSymbolCoin: null,
  currentCoinCode: ECurrencyCode.DOLLAR,
  convertToCurrency: () => null,
};

export default CardProductSelected;
